import { render, staticRenderFns } from "./CurePlanForm.vue?vue&type=template&id=4ac2afd2&scoped=true&"
import script from "./CurePlanForm.vue?vue&type=script&lang=js&"
export * from "./CurePlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac2afd2",
  null
  
)

export default component.exports